import {
    ClickElement,
    ClickText,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

function trackPaybackInfoClicked(paybackPoints: number): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'IconClick',
            label: 'Info_PaybackCollect',
            eventData: {
                eventName: GA4EventName.ClickButton,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                click_element: ClickElement.PaybackInformation,
                click_text: `${paybackPoints} °P`,
            },
        });
    }, 0);
}

function trackPaybackAdditionalInfoClicked(url: string): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'TextClick',
            label: 'AdditionalInfo_Payback',
            eventData: {
                eventName: GA4EventName.ClickTextLink,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                click_element: ClickElement.PaybackAdditionalInformation,
                click_text: ClickText.AdditionalInformation,
                click_url: url,
            },
        });
    }, 0);
}

export { trackPaybackAdditionalInfoClicked, trackPaybackInfoClicked };
